import { useState, useEffect, useRef, useCallback } from 'react';

const useMessageHandler = (processDataCallback) => {
  const [neblaConfirm, setNeblaConfirm] = useState({
    status: false,
    data: null,
  });
  const isProcessedRef = useRef(false);

  const handleMessage = useCallback(
    (event) => {
      if (event.source !== window) return;

      const nablaCopilot = event.data?.nablaCopilot;
      if (nablaCopilot?.note !== undefined && !isProcessedRef.current) {
        const shouldUpdate = processDataCallback
          ? processDataCallback(event.data)
          : true;

        if (shouldUpdate) {
          setNeblaConfirm((prev) => ({
            ...prev,
            status: true,
            data: event.data,
          }));
          isProcessedRef.current = true;
        }
      }
    },
    [processDataCallback]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [handleMessage]);

  const resetHandler = useCallback(() => {
    setNeblaConfirm({ status: false, data: null });
    isProcessedRef.current = false;
  }, []);

  return { neblaConfirm, resetHandler };
};

export default useMessageHandler;
